/**
 * Enum de type d'alerte remonté par le back
 * Utilisé pour afficher une alerte remonté par le back 
 */
export enum AlerteType {
    ENVELOPPE_VIDE = "enveloppe_vide"
}